import Vue from 'vue'
import VueRouter from 'vue-router';
import Home from './views/Home.vue'
import About from './views/About.vue';
import Login from './views/Login.vue';
import Meetings from './views/Meetings.vue';
import Register from './views/Register.vue';
import CheckIn from './views/CheckIn.vue';
import Attendees from './views/Attendees.vue';

Vue.use(VueRouter);

export default new VueRouter({

    routes: [
        {
            path: "/",
            name: "home",
            component: Home

        },
        {
            path: '/about',
            name: 'about',
            component: About
          },
          {
            path: '/login',
            name: 'login',
            component: Login
          },
          {
            path: '/register',
            name: 'register',
            component: Register
          },
          {
            path: '/meetings',
            name: 'meetings',
            component: Meetings
          },
          {
            path: "/checkin/:userID/:meetingID",
            name: "CheckIn",
            component: CheckIn

          },
          {
            path: "/attendees/:userID/:meetingID",
            name: "Attendees",
            component: Attendees

          },
          // All non-sense route
          {
            path: '*',
            redirect: "/"            
          }
    ]

})

